var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "slideInUp", delay: 0, duration: 300 },
          expression: "{ classes: 'slideInUp', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "cache-widget",
    },
    [
      _c(
        "div",
        { staticClass: "widget-header" },
        [
          _c("div", { staticClass: "header-left" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("storage")]),
            _vm._v(" "),
            _c("div", { staticClass: "header-text" }, [
              _c("strong", [_vm._v(_vm._s(_vm.$t("Cache Yönetimi")))]),
              _vm._v(" "),
              _c("small", [_vm._v(_vm._s(_vm.automation.name))]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-icon-button",
              on: {
                click: function ($event) {
                  return _vm.$emit("close-menu", 0)
                },
              },
            },
            [_c("md-icon", [_vm._v("close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "widget-body" },
        [
          _c("CacheManager", {
            attrs: {
              "default-filters": {
                actorType: "automation",
                actorId: _vm.automation._id,
              },
              "modal-mode": true,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }